import { createTheme } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";

const fontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';

const learningCenterDarkTheme = (primaryColor, secondaryColor) => ({
  palette: {
    mode: "dark",
    action: {
      active: "#fff"
    },
    text: {
      primary: "#fff",
      secondary: "rgba(255, 255, 255, 0.7)"
    },
    primary: {
      contrastText: "rgba(0, 0, 0, 0.87)",
      dark: "rgb(178, 178, 178)",
      light: "rgb(255, 255, 255)",
      main: "#fff"
    }
  },

  components: {
    MuiButton: {
      styleOverrides: {
        outlined: {
          border: "solid 1px #fff !important"
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        colorPrimary: {
          color: "rgba(0, 0, 0, 0.6)"
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        colorSecondary: {
          color: "rgba(0, 0, 0, 0.6)"
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        popperInteractive: {
          "& p": {
            color: "rgba(0, 0, 0, 0.6)"
          }
        }
      }
    }
  },
  typography: {
    fontFamily,
    body1: {
      fontFamily
    },
    body2: {
      fontFamily
    },
    button: {
      fontFamily
    },
    caption: {
      fontFamily
    },
    h1: {
      fontFamily
    },
    h2: {
      fontFamily
    },
    h3: {
      fontFamily
    },
    h4: {
      fontFamily
    },
    h5: {
      fontFamily
    },
    h6: {
      fontFamily
    },
    overline: {
      fontFamily
    },
    subtitle1: {
      fontFamily
    },
    subtitle2: {
      fontFamily
    }
  }
});

const theme = outerTheme => {
  const nestedTheme = createTheme(
    deepmerge(
      outerTheme,
      learningCenterDarkTheme(
        outerTheme.palette.primary.main,
        outerTheme.palette.secondary.main
      )
    )
  );

  return nestedTheme;
};

export default theme;
